module.exports = __webpack_public_path__ + "img/199-8d7ca6.png";